import { createContext } from 'react';

const SideNavigationContext = createContext();

export default SideNavigationContext;
